import {
  CreateSquadRequest,
  SquadDTO,
  SquadPessoaDTO,
  UpdateSquadRequest,
} from "@/types/squad.type";
import { SquadEstatisticasDTO } from "@/types/squad-estatisticas.type";
import { httpClient } from "./httpClient";
import { SquadFiltrosCriteria, SquadFiltrosOptions } from "@workflow/types";
import { buildQueryParams } from "@/utils/build-query-params";
import { PageResponse } from "@/types/http.type";

export class SquadService {
  private readonly basePath = "/api/v1/squads";

  public async listSquads(filter: SquadFiltrosCriteria) {
    let url = `${this.basePath}`;

    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }

    return await httpClient.get<PageResponse<SquadDTO>>(url);
  }

  public async getAll() {
    return await httpClient.get<SquadDTO[]>(`${this.basePath}/all`);
  }

  public async getSquadById(id: number) {
    return await httpClient.get<SquadDTO>(`${this.basePath}/${id}`);
  }

  public async getSquadsByPessoaId(pessoaId: number) {
    return await httpClient.get<SquadDTO[]>(`${this.basePath}/pessoa/${pessoaId}`);
  }

  public async getMySquads() {
    return await httpClient.get<SquadDTO[]>(`${this.basePath}/me`);
  }

  public async getMembersBySquadId(squadId: number) {
    return await httpClient.get<SquadPessoaDTO[]>(`${this.basePath}/${squadId}/membros`);
  }

  public async getFiltros() {
    return await httpClient.get<SquadFiltrosOptions>(`${this.basePath}/filtros`);
  }

  public async getEstatisticas() {
    return await httpClient.get<SquadEstatisticasDTO>(`${this.basePath}/estatisticas/mais-membros`);
  }

  public async createSquad(squad: CreateSquadRequest) {
    return await httpClient.post<SquadDTO>(this.basePath, squad);
  }

  public async updateSquad(id: number, squad: UpdateSquadRequest) {
    return await httpClient.put<SquadDTO>(`${this.basePath}/${id}`, squad);
  }

  public async inactivateSquad(id: number) {
    return await httpClient.patch<SquadDTO>(`${this.basePath}/${id}/inativar`);
  }

  public async reactivateSquad(id: number) {
    return await httpClient.patch<SquadDTO>(`${this.basePath}/${id}/reativar`);
  }

  public async vincularMembro(squadId: number, pessoaId: number) {
    return await httpClient.post<SquadPessoaDTO>(`${this.basePath}/${squadId}/membros`, {
      pessoaId,
    });
  }

  public async removerMembro(squadId: number, pessoaId: number) {
    return await httpClient.delete<{ message: string }>(
      `${this.basePath}/${squadId}/membros/${pessoaId}`,
    );
  }
}

export const squadService = new SquadService();
